<template>
  <div class="offer-content" itemtype="https://schema.org/Offer" itemscope="1">
    <div class="mb-12">
      <a-row :gutter="32" type="flex">
        <a-col :xs="24" :lg="16" :xl="17">
          <div class="offer-title">
            <div
              v-if="!hotelNameReady"
              class="offer-title__heading-placeholder placeholder-animated"
            ></div>
            <h1 v-else class="offer-title__heading">
              {{ offerObjectName }}
              <T1Stars class="offer-title__category" :number="category" />
            </h1>
            <meta :content="offerObjectName" itemprop="name" />
            <template v-if="pricevisible">
              <meta :content="ourCode + tourOp + '-' + code" itemprop="mpn" />
              <meta :content="price" itemprop="price" />
              <meta :content="fromDate" itemprop="priceValidUntil" />
              <meta content="Yes" itemprop="availability" />
            </template>
            <template v-else>
              <meta content="No" itemprop="availability" />
            </template>
            <meta content="PLN" itemprop="priceCurrency" />
            <div
              v-if="!regionReady"
              class="offer-title__region-placeholder placeholder-animated"
            ></div>
            <template v-else>
              <div
                v-if="region && xcity && offerType != 'R'"
                class="offer-title__region"
              >
                <template v-if="region != ''">{{ region }}</template>
                <template v-if="xcity != ''">, {{ xcity }} </template>
              </div>
              <div v-else>Wycieczka objazdowa</div>
            </template>
          </div>
        </a-col>
        <a-col :xs="24" :lg="8" :xl="7">
          <div class="offer-actions" v-show="pricevisible">
            <a
              :href="getUrlSchowka()"
              class="action-button"
              title="Dodaj ofertę do schowka"
            >
              <span class="action-button__svg" aria-hidden="true">
                <svg class="svg-icon__svg" focusable="false">
                  <use
                    xlink:href="/img/static/svg-sprites.svg#icon-heart-o"
                  ></use>
                </svg>
              </span>
              <span class="action-label">Dodaj do schowka</span>
            </a>
            <a
              :href="getDirectLink()"
              class="action-button"
              title="Kopiuj link oferty"
              v-on:click.prevent
              @click="copy(getDirectLink())"
            >
              <span class="action-button__svg" aria-hidden="true">
                <svg class="svg-icon__svg" focusable="false">
                  <use xlink:href="/img/static/svg-sprites.svg#icon-link"></use>
                </svg>
              </span>
              <span class="action-label">Kopiuj link oferty</span>
            </a>
          </div>
        </a-col>
      </a-row>
    </div>
    <a-row :gutter="32">
      <a-col :lg="16" :xl="17" class="float-lg-left">
        <div class="gallery-panel">
          <template v-if="windowWidth < 768">
            <T1GallerySlider :images="images" />
          </template>
          <template v-else>
            <T1GalleryTiles
              :images="images"
              :objectName="offerObjectName"
              :category="category"
            />
          </template>
        </div>
        <T1HotelAttributesPlaceholder v-if="!hattrsVisible" />
        <T1HotelAttributes v-else :attributes="hotelAttributes" />
      </a-col>

      <a-col :lg="8" :xl="7" class="float-md-right">
        <T1OfferConfigSearcher />
        <template
          v-if="
            pricevisible && tripDetails.type != '' && tripDetails.type != 'H'
          "
        >
          <div class="mb-32">
            <div class="h3 font-20 mb-16">Szczegóły podróży</div>
            <T1TripInfoWidget v-if="tripDetails" :tripDetails="tripDetails" />
          </div>
        </template>
      </a-col>

      <a-col :lg="16" :xl="17" class="float-md-left">
        <div class="layout-segment">
          <div class="">
            <T1Tabs v-if="tabsReady" tabLabelType="h2" :defaultActiveKey="1">
              <T1Tab
                v-show="descriptionsData.length"
                key="1"
                title="Opis oferty"
                renderContent
              >
                <T1Descriptions :descriptionsData="descriptionsData" :omitDecode="false" />
              </T1Tab>
              <T1Tab
                v-if="getXCodeValid() && getGeoValid()"
                key="2"
                title="Lokalizacja"
                renderContent
              >
                <T1Map v-if="mapCoords" :mapCoords="mapCoords" />
              </T1Tab>
              <T1Tab key="3" title="Oferty z okolicy">
                <T1Offers :locid="getHlocid()" />
              </T1Tab>
              <T1Tab
                key="4"
                title="Klimat"
                v-if="meteoData.KiedyJechac && climateData"
              >
                <T1WhenToGo
                  class="pb-12"
                  v-if="meteoData.KiedyJechac"
                  :meteoDesc="meteoData.KiedyJechac"
                  :countryName="countryname"
                />
                <T1MeteoCharts v-if="climateData" :climateData="climateData" />
              </T1Tab>
            </T1Tabs>
          </div>
        </div>
        <T1ForecastWidget
          :wname="locName"
          :hlocid.sync="hlocid"
          v-if="hlocid"
        />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import T1Stars from "./T1Shared/T1Stars";
import T1GallerySlider from "./T1Gallery/T1GallerySlider";
import T1GalleryTiles from "./T1Gallery/T1GalleryTiles";
import T1HotelAttributes from "./T1HotelAttributes";
import T1HotelAttributesPlaceholder from "./T1Placeholders/T1HotelAttributesPlaceholder";
import T1Tabs from "./T1Tabs/T1Tabs";
import T1Tab from "./T1Tabs/T1Tab";
import T1Descriptions from "./T1TabsContent/T1Descriptions";
import T1MeteoCharts from "./T1PogodaKlimat/T1MeteoCharts";
import T1WhenToGo from "./T1PogodaKlimat/T1WhenToGo";
import T1ForecastWidget from "./T1PogodaKlimat/T1ForecastWidget";
import T1OfferConfigSearcher from "./T1Searchers/T1OfferConfigSearcher";
import T1TripInfoWidget from "./T1TripInfo/T1TripInfoWidget";
import T1Map from "./T1TabsContent/T1Map";
import T1Offers from "./T1TabsContent/T1Offers.vue";
import T1VarLoader from "./T1VarLoader";
import axios from "axios";
import * as CONFIG from "./config.js";
import { notification } from "ant-design-vue";

// const max_carousel_pics = 10;

axios.defaults.withCredentials = false;

export default {
  props: {
    hlocid: String,
  },
  data: () => ({
    //url: "/getdatagopics.json",
    url:
      "https://www-test.travelone.pl/" +
      CONFIG.panstwo_id +
      "/testdatagopics.xml",
    merlinXMLURL: "",
    meteourl: "/getvuemeteodata.json",
    countryname: CONFIG.panstwo_nazwapl,
    dparams: "",
    pics: [],
    // picsfiltered: [],
    images: [],
    // hotel: "",
    offerType: "",
    offerObjectName: "",
    price: "",
    oldprice: "",
    discount: "",
    pricevisible: false,
    category: "",
    tourOp: "",
    code: "",
    hattrsVisible: false,
    hotelAttributes: [],
    locName: "",
    xCode: "",
    directlink: "",
    clipboardUrl: "",
    tripDetails: [],
    climateLocid: "",
    climateData: {},
    meteoData: {},
    ourCode: CONFIG.panstwo_kod,
    fromDate: "",
    geoValid: true,
    descriptionsData: [],
    lat: "",
    lng: "",
    mapCoords: [],
    region: "",
    xcity: "",
    defaultImage: "https://www.travelone.pl/newimgs/zaslepka_lato.jpg",
    hotelNameReady: false,
    regionReady: false,
    titleReady: false,
    tabsReady: false,
    windowWidth: window.innerWidth,
  }),
  methods: {
    getTitleReady() {
      if (this.hotelNameReady) {
        return true;
      }
    },
    getGeoValid() {
      return this.geoValid;
    },
    getXCodeValid() {
      if (this.xCode != null && this.xCode.indexOf("-") != -1) {
        return false;
      } else {
        return true;
      }
    },
    async copy(s) {
      try {
        await navigator.clipboard.writeText(s);
        // console.log("URL copied!");
      } catch (err) {
        // console.log("Failed: ", err);
      }
      this.openNotificationWithIcon("success");
    },
    openNotificationWithIcon(type) {
      notification[type]({
        duration: 2,
        message: "Skopiowano link do schowka",
        top: "9px",
      });
    },
    getSchowekPrefix() {
      return "https://www.travelone.pl/oferta/schowek.xml?oper=add&";
    },
    getUrlSchowka() {
      return this.getSchowekPrefix() + this.clipboardUrl + this.directlink;
    },
    getDirectLink() {
      return (
        window.location.origin +
        decodeURIComponent(this.$route.path) +
        "?" +
        this.directlink
      );
    },
    getHlocid() {
      return this.hlocid;
    },
    getCarouselXMLItems() {
      var pars = this.dparams;
      return axios
        .get("https://data.travelone.pl/rest/vue2api/getmopisy.xml?url=" + this.merlinXMLURL, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/xml",
          },
        })
        .then((response) => {
          /*alert("DATA:" + response.data);
            alert("STATUS:" + response.status);
            alert("DATA ITEMS:" + JSON.stringify(response.data));*/
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getCarouselItems() {
      var pars = this.dparams;
      return axios
        .get(this.url + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/xml",
          },
        })
        .then((response) => {
          /*alert("DATA:" + response.data);
            alert("STATUS:" + response.status);
            alert("DATA ITEMS:" + JSON.stringify(response.data));*/
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getMeteoData() {
      var pars = "locid=" + this.climateLocid;
      return axios
        .get(CONFIG.API_URL + this.meteourl + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getQueryParams() {
      let lparams = this.$route.query;
      if (lparams["kodId"]) {
        let val = decodeURIComponent(lparams["kodId"]);
        this.dparams = "kodId=" + val;
      }
    },
    getMapCoords(objName, latVal, lngVal) {
      let mapCoordsArr = [];

      mapCoordsArr.push({
        hotelName: objName,
        lat: latVal,
        lng: lngVal,
        typMapy: "hybrydowa",
        zoom: "",
      });
      this.mapCoords = mapCoordsArr;
    },
    tomatrix(obj) {
      if (obj != undefined) {
        if (obj instanceof Array) {
          return obj;
        } else {
          let z = [];
          z.push(obj.picture);
          return z;
        }
      } else {
        return [];
      }
    },
  },
  mounted() {
    var that = this;
    var path = this.$route.path;
    var routepars = this.$route.query;
    if (routepars["xCode"]) {
      this.xCode = routepars["xCode"];
    }
    T1VarLoader.loadMissingURLParams(path).then((data) => {
      var xmlObj = jQuery(data);
      that.$cheapest_naszlocid = xmlObj.find("naszlocid").text();
      that.$cheapest_kodId = xmlObj.find("ofr").attr("id");
      that.$cheapest_mdesc = xmlObj.find("metadescription").text();
      that.$cheapest_mtitle = xmlObj.find("metatitle").text();
      if (that.$cheapest_naszlocid != "") {
        that.$root.$emit("update:hlocid", that.$cheapest_naszlocid);
      }
      if (that.$cheapest_mdesc != "") {
        that.$root.$emit("update:mdesc", that.$cheapest_mdesc);
      }
      if (that.$cheapest_mtitle != "") {
        that.$root.$emit("update:mtitle", that.$cheapest_mtitle);
      }
      if (routepars["kodId"]) {
        this.getQueryParams();
      } else {
        this.dparams = "kodId=" + that.$cheapest_kodId;
      }
      this.getCarouselItems().then((data) => {
        var xmlObj = jQuery(data);
        var merlinurl = xmlObj.find("Merlin").text();
        console.log("MERLIN:" + merlinurl);
        that.merlinXMLURL = merlinurl;
        that.getCarouselXMLItems().then((dataxml) => {
          var xmlObj2 = jQuery(dataxml);
          console.log("XML:" + xmlObj2);
          that.images = [];
          xmlObj2.find("picture").each(function (index, elem) {
            var pic = jQuery(elem).text();
            that.images.push({ txt: pic });
          });

          if (that.images.length < 1) {
            that.images = [{ txt: that.defaultImage }];
          }

          let hotelDataDescArr = [];
          xmlObj2.find("text").each(function (index, elem) {
            var objcontent = jQuery(elem).find("content").html();
            var objsubject = jQuery(elem).find("subject").html();
            if (
              objcontent != "<br/>" &&
              objcontent != "" &&
              objcontent != "&nbsp;"
            ) {
              hotelDataDescArr.push({
                title: objsubject,
                content: objcontent,
              });
            }
          });
          that.descriptionsData = hotelDataDescArr;
        });
        // alert('ITEMS:' + JSON.stringify(data.Page.main.hotelData));
        /*if (data != null && typeof data != "string") {
            if (
              data.Page.main.hotelData &&
              data.Page.main.hotelData.images &&
              data.Page.main.hotelData.images.pictures
            ) {
              this.pics = this.tomatrix(
                data.Page.main.hotelData.images.pictures
              );

              this.images = this.pics;

              // this.picsfiltered = this.pics;
              // this.picsfiltered.length =
              //   max_carousel_pics < this.pics.length
              //     ? max_carousel_pics
              //     : this.pics.length;
            } else {
              // this.picsfiltered = [{ txt: this.defaultImage }];

              this.images = [{ txt: this.defaultImage }];
            }
            if (data.Page.main.hotelData && data.Page.main.hotelData.texts) {
              let hotelDataDesc = data.Page.main.hotelData.texts;
              let hotelDataDescArr = [];

              hotelDataDesc.forEach(function (obj, idx) {
                if (
                  obj.content != "<br/>" &&
                  obj.content != "" &&
                  obj.content != "&nbsp;"
                ) {
                  hotelDataDescArr.push({
                    title: obj.subject,
                    content: obj.content,
                  });
                }
              });
              this.descriptionsData = hotelDataDescArr;
            }
            if (
              data.Page &&
              data.Page.main &&
              data.Page.main.hotelData &&
              data.Page.main.hotelData.hotel &&
              data.Page.main.hotelData.hotel instanceof Array
            ) {
              this.hotel = "Hotel";
            } else {
              this.hotel = data.Page.main.hotelData.hotel;
            }
            this.$root.$emit("update:hotel", this.hotel);
          } else {
            // this.picsfiltered = [{ txt: this.defaultImage }];

            this.images = [{ txt: this.defaultImage }];
          }
          this.tabsReady = true;
        })
        .catch(() => {
          // this.picsfiltered = [{ txt: this.defaultImage }];
          this.tabsReady = true;
        });*/
      });
      this.hotel = "Hotel";
      this.$root.$emit("update:hotel", this.hotel);
      this.tabsReady = true;
    });

    this.$root.$on("update:climateLocid", (val1) => {
      that.climateLocid = val1;
      that.getMeteoData().then((data) => {
        this.meteoData = data.Page.MeteoData;
        this.climateData = this.meteoData.location.climatedata;
      });
    });

    this.$root.$on("update:price", (val1) => {
      that.price = val1;
    });
    this.$root.$on("update:oldprice", (val1) => {
      that.oldprice = val1;
    });
    this.$root.$on("update:discount", (val1) => {
      that.discount = val1;
    });
    this.$root.$on("update:pricevisible", (val1) => {
      that.pricevisible = val1;
    });
    this.$root.$on("update:tourOp", (val1) => {
      that.tourOp = val1;
    });
    this.$root.$on("update:code", (val1) => {
      that.code = val1;
    });
    this.$root.$on("update:category", (val1) => {
      that.category = val1;
    });
    this.$root.$on("update:hattrsVisible", (val1) => {
      that.hattrsVisible = val1;
    });
    this.$root.$on("update:hotelAttributes", (val1) => {
      that.hotelAttributes = val1;
    });
    this.$root.$on("update:directlink", (val1) => {
      that.directlink = val1;
    });
    this.$root.$on("update:tripDetails", (val1) => {
      that.tripDetails = val1;
    });
    this.$root.$on("update:fromDate", (val1) => {
      that.fromDate = val1;
    });
    this.$root.$on("update:geovalid", (val1) => {
      that.geoValid = false;
    });
    this.$root.$on("update:latLongVals", (val1) => {
      this.getMapCoords(val1[0].objName, val1[0].lat, val1[0].lng);
    });
    this.$root.$on("update:region", (val1) => {
      that.region = val1;
    });
    this.$root.$on("update:xcity", (val1) => {
      that.xcity = val1;
    });
    this.$root.$on("update:offerType", (val1) => {
      that.offerType = val1;
    });
    this.$root.$on("update:ofrObjName", (val1) => {
      that.offerObjectName = val1;
    });

    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  updated() {
    if (this.offerObjectName && this.category) {
      this.hotelNameReady = true;

      if (this.hotelNameReady && this.region) {
        this.regionReady = true;
      } else if (this.hotelNameReady && !this.region) {
        this.regionReady = true;
      }
    }
  },
  components: {
    T1Stars,
    T1GallerySlider,
    T1GalleryTiles,
    T1HotelAttributes,
    T1HotelAttributesPlaceholder,
    T1Tabs,
    T1Tab,
    T1MeteoCharts,
    T1WhenToGo,
    T1OfferConfigSearcher,
    T1TripInfoWidget,
    T1ForecastWidget,
    T1Offers,
    T1VarLoader,
    T1Map,
    T1Descriptions,
  },
};
</script>

<style lang="scss" scoped>
.gallery-panel {
  margin-bottom: 24px;

  @media (max-width: $screen-xs-max) {
    margin-left: -16px;
    margin-right: -16px;
  }
}

.offer-title {
  &__heading {
    font-size: 22px;
    margin-bottom: 4px;

    @media (min-width: $screen-sm) {
      font-size: 24px;
    }
  }

  &__category {
    color: darken($yellow-default, 5%);
    font-size: 14px;
    position: relative;
    top: -6px;
  }

  &__heading-placeholder {
    border-radius: 2px;
    height: 25px;
    width: 100%;
    margin-bottom: 6px;
    max-width: 320px;

    @media (min-width: $screen-sm) {
      height: 28px;
    }
  }

  &__subline {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 2px;
  }

  &__region {
    @include text-truncate();
    color: $gray-50;
  }

  &__region-placeholder {
    border-radius: 2px;
    height: 23px;
    width: 100%;
    max-width: 220px;
  }
}

.offer-actions {
  display: flex;

  @media (max-width: $screen-sm-max) {
    position: absolute;
    right: 14px;
    bottom: -60px;
    z-index: 1;
  }

  @media (min-width: $screen-sm) and (max-width: $screen-sm-max) {
    right: 32px;
  }

  @media (min-width: $screen-md) {
    align-items: flex-end;
    justify-content: flex-end;
    height: 100%;
  }

  .action-button {
    display: flex;
    align-items: center;

    &__svg {
      display: flex;
    }

    @media (max-width: $screen-sm-max) {
      color: #fff;
      background-color: rgba(0, 0, 0, 0.45);
      border-radius: 2px;
      justify-content: center;
      opacity: 0.75;
      transition: all ease-in-out 0.15s;
      height: 32px;
      width: 32px;

      &__svg {
        height: 20px;
        width: 20px;
      }

      &:hover {
        color: $orange-default;
        background-color: rgba(0, 0, 0, 0.75);
      }

      .action-label {
        display: none;
      }
    }

    &:not(:last-of-type) {
      margin-right: 12px;
    }

    @media (min-width: $screen-md) {
      color: $gray-50;
      font-size: 14px;

      &__svg {
        margin-right: 4px;
        height: 14px;
        width: 14px;
      }
    }
  }
}
</style>
